import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { agreementCreateToDto, agreementFromDto, agreementListFromDto, agreementUpdateToDto } from '@/features/agreements/mappers/agreementsMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'agreements';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
};

export const getAgreements = async (data = {}) => {
  const params = {
    active: data.active,  // Opcional. Si no se proporciona, se retornan todos los convenios
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return response.data.map(agreementListFromDto);
};

export const getAgreement = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return agreementFromDto(response.data);
};

export const createAgreement = async (data) => {
  const payload = agreementCreateToDto(data);
  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return agreementFromDto(response.data);
};

export const updateAgreement = async (id, data) => {
  validateRequiredFields({ id });

  const payload = agreementUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return agreementFromDto(response.data);
};

/** El endpoint responde con un código 204 (No Content), por lo que no se retorna ningún valor. */
export const deleteAgreement = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id });
  await api.delete(endpoint);
};

export const restoreAgreement = async (id) => {
  validateRequiredFields({ id });

  const endpoint = buildServiceEndpoint({ id, action: 'restore' });
  const response = await api.post(endpoint);
  return agreementFromDto(response.data);
};